import { render } from "./RelativeEditComponent.vue?vue&type=template&id=9ba2076e&scoped=true"
import script from "./RelativeEditComponent.vue?vue&type=script&lang=js"
export * from "./RelativeEditComponent.vue?vue&type=script&lang=js"

import "./RelativeEditComponent.vue?vue&type=style&index=0&id=9ba2076e&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ba2076e"]])

export default __exports__